import React, { useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';
import { safeUrl } from '../utils/sanitize';

const getParent = () => {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' ? 'localhost' : h;
};

const formatNum = (n) => {
  if (!n) return '0';
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000)    return (n / 1000).toFixed(1) + 'K';
  return String(n);
};

const ClipPlayerModal = ({ clip, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!clip) return null;

  const embedUrl = `https://clips.twitch.tv/embed?clip=${encodeURIComponent(clip.id)}&parent=${encodeURIComponent(getParent())}&autoplay=true`;
  const safeClipUrl = safeUrl(clip.url);

  return (
    <div
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.93)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}
      onClick={onClose}
    >
      <div
        style={{ width:'100%', maxWidth:920, background:'#000', border:'1px solid #2a2a2a' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', padding:'0.75rem 1rem', borderBottom:'1px solid #1a1a1a' }}>
          <div style={{ flex:1, minWidth:0 }}>
            <p style={{ fontFamily:'"JetBrains Mono", monospace', fontSize:'0.6rem', color:'#555', letterSpacing:'0.15em', textTransform:'uppercase', marginBottom:3 }}>
              NOW PLAYING{clip.broadcaster_name ? ` · ${clip.broadcaster_name}` : ''}
            </p>
            <p style={{ fontSize:'0.9rem', color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', margin:0 }}>
              {clip.title}
            </p>
          </div>
          {safeClipUrl && <a
            href={safeClipUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="Open on Twitch"
            style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'none', border:'1px solid #2a2a2a', color:'#555', width:32, height:32, flexShrink:0, textDecoration:'none' }}
            onClick={e => e.stopPropagation()}
          >
            <ExternalLink size={13} />
          </a>}
          <button
            onClick={onClose}
            style={{ display:'flex', alignItems:'center', justifyContent:'center', background:'none', border:'1px solid #2a2a2a', color:'#555', width:32, height:32, cursor:'pointer', flexShrink:0 }}
          >
            <X size={15} />
          </button>
        </div>

        {/* Player */}
        <div style={{ position:'relative', paddingTop:'56.25%', background:'#0a0a0a' }}>
          <iframe
            src={embedUrl}
            style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', border:'none' }}
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-presentation"
            title={clip.title}
          />
        </div>

        {/* Footer */}
        <div style={{ display:'flex', gap:'1.5rem', padding:'0.6rem 1rem', borderTop:'1px solid #1a1a1a' }}>
          {clip.view_count != null && (
            <span style={{ fontFamily:'"JetBrains Mono", monospace', fontSize:'0.6rem', color:'#444', letterSpacing:'0.1em' }}>
              {formatNum(clip.view_count)} VIEWS
            </span>
          )}
          {clip.game_name && (
            <span style={{ fontFamily:'"JetBrains Mono", monospace', fontSize:'0.6rem', color:'#444', letterSpacing:'0.1em' }}>
              {clip.game_name.toUpperCase()}
            </span>
          )}
          <span style={{ fontFamily:'"JetBrains Mono", monospace', fontSize:'0.6rem', color:'#333', marginLeft:'auto', letterSpacing:'0.1em' }}>
            ESC TO CLOSE
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClipPlayerModal;
